import { FC } from 'react';
import { Intro } from '../Intro/Intro';
import { Links } from '../Links/Links';
import { LanguageSwitcher } from '../LanguageSwitcher/LanguageSwitcher';
import { Version } from 'Components/Version/Version';

export const Content: FC = () => {
    return (
        <main id="main">
            <LanguageSwitcher />
            <Intro />
            <Links />
            <Version />
        </main>
    );
};
